import React, { useState, useEffect } from 'react';
import '../Review.css';
import {
    Grid, Box, Chip, TextField, Typography, TextareaAutosize, MenuItem, Button, Divider, Backdrop, CircularProgress,
    Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Paper, Stack, Modal
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { DataGrid } from "@mui/x-data-grid";
import moment from 'moment';
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CommentIcon from '@mui/icons-material/Comment';
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { SaveOutlined, DrawRounded, TaskAltOutlined, DownloadOutlined, UploadOutlined, Close, UploadFile, TaskAltRounded, AccessibilityNewOutlined, SpeakerNotesOutlined, DoNotDisturbOutlined } from '@mui/icons-material';
//import Dropzone from "react-dropzone";
//import Draggable from 'react-draggable';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { GetOrderStatus, GetScenarios, GetQuotaDetailsForScenario, GetWeekStatus, setState, reset } from '../reviewSlice';
import QuotaandConsumption from './QuotaandConsumption';
import CollapseSection from '../../../components/ui/CollapseSection';
import Modification from './Modification';
import { green, orange, red, grey, blue } from '@mui/material/colors';
import MessageForReview from '../MessageForReview'
import './Modification.css';
import ExportIcons from './ExportIcons';

// Define a function to get Chip properties based on cell value
function getChipProps(params) {
    if (params.value === 1) {
        return {
            label: "Low",
            style: {
                fontWeight: 'bold',
                //borderColor: green[500],
                backgroundColor: green[50],
                color: green[500],
            },
        };
    }

    else if (params.value === 2) {
        return {
            label: "Medium",
            style: {
                fontWeight: 'bold',
                borderColor: orange[500],
                backgroundColor: orange[50],
                color: orange[500]
            },
        };
    }

    else if (params.value === 3) {
        return {
            label: "High",
            style: {
                fontWeight: 'bold',
                borderColor: red[500],
                backgroundColor: red[50],
                color: red[500]
            },
        };
    }

    else if (params.value === 4) {
        return {
            label: "Severe",
            style: {
                fontWeight: 'bold',
                borderColor: grey[500],
                backgroundColor: grey[50],
                color: grey[500]
            },
        };
    }

    else {
        return {
            label: "Other",
            style: {
                fontWeight: 'bold',
                borderColor: blue[500],
                backgroundColor: blue[50],
                color: blue[500]
            },
        };
    }
}

let w = 135;
const columns = [
    { field: "scenarioName", headerName: "Scenario", flex: 1, minWidth: 100 },
    {
        field: "geoCode",
        headerName: "Country",
        flex: 0.5, minWidth: 100,
    },
    {
        field: "criticalityId",
        headerName: "Criticality",
        flex: 0.5, minWidth: 100,
        renderCell: (params) => {
            return <Chip sx={{ height: '1.2rem' }} variant="outlined" {...getChipProps(params)} />;
        },
        // renderCell: (cellValues) => {
        //     let iconStyle = "";
        //     if (cellValues.value === 1) {
        //         iconStyle = "green";
        //         cellValues.value = "Low";
        //     } else if (cellValues.value === 2) {
        //         iconStyle = "orange";
        //         cellValues.value = "Medium";
        //     } else if (cellValues.value === 3) {
        //         iconStyle = "red";
        //         cellValues.value = "High";
        //     } else if (cellValues.value === 4) {
        //         iconStyle = "black";
        //         cellValues.value = "Severe";
        //     } else {
        //         iconStyle = "blue";
        //         cellValues.value = "Other";
        //     }
        //     return (
        //         <span title={cellValues.value}>
        //             <FiberManualRecordIcon color={iconStyle} /> {" "}
        //         </span>
        //     );
        // },
    },
    {
        field: "orderStatus",
        headerName: "Order Status",
        flex: 0.5, minWidth: 100
    },
    {
        field: "quota",
        headerName: "Quota",
        flex: 0.8, minWidth: 100,
        valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString();
            return formattedValue;
        }
    },
    {
        field: "consumption",
        headerName: "Actual Consumption",
        flex: 1, minWidth: 100,
        valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString();
            return formattedValue;
        }
    },
    {
        field: "todaysConsumption",
        headerName: "Today's Consumption",
        flex: 1, minWidth: 100,
        valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString();
            return formattedValue;
        }
    },
    {
        field: "yesterdaysConsumption",
        headerName: "Yesterday's Consumption",
        flex: 1, minWidth: 100,
        valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString();
            return formattedValue;
        }
    },
    {
        field: "noOfBlockedCustomers",
        headerName: "No of blocked customers",
        flex: 1, minWidth: 100,
    },
    {
        field: "intendedQuantity",
        headerName: "Intended Quantity",
        flex: 1, minWidth: 100,
        valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString();
            return formattedValue;
        }
    },
    // {
    //     field: "deliveredQty",
    //     headerName: "Delivered Quantity",
    //     flex: 1, minWidth: 100,
    // },
    {
        field: "sapRefresh",
        headerName: "SAP DayStamp",
        flex: 1, minWidth: 100,
        type: "date",
        valueFormatter: params => {
            const sapRefreshValue = params?.value;
            if (sapRefreshValue && sapRefreshValue.toString().indexOf('0001') >= 0) {
                // Set sapRefresh to null if the condition is met
                return "";
            }
            return moment(sapRefreshValue).format("DD/MM/YYYY");
        },
    },
    // {
    //     field: "quotaID",
    //     headerName: "Quota ID",
    //     hide: true,
    // },
];


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};


const ReviewOrdersandQuota = () => {
    const dispatch = useDispatch();
    const [isCollapseOpened, setIsCollapseOpened] = useState(false);
    const [isModificationOpened, setIsModificationOpened] = useState(false);
    const [open, setOpen] = useState(false)
    const review = useSelector((state) => state.review);
    const {
        isLoading,
        countries,
        selectedCountry,
        selectedCountryID,
        orderStatus,
        selectedOrderStatus,
        selectedPeriod,
        getScenarios,
        displayModification,
        clearQCTable,
        searchTxt,
        isNavigate,
        isCollapseOpen,
        clearReviewTable,
        getQuotaDetails
    } = review;
    const [searchText, setSearchText] = useState(searchTxt);


    const [rows, setRows] = useState([]);

    useEffect(() => {
        if (orderStatus.length <= 0) {
            dispatch(GetOrderStatus({ method: "Get" }));
        }
    }, []);
    useEffect(() => {
        setIsCollapseOpened(isCollapseOpen);
    }, [isCollapseOpen]);
    useEffect(() => {
        if (!isNavigate) {
            dispatch(reset("refresh"));
        } else {
            dispatch(reset("navigate"));
            dispatch(setState("isNavigate", false));
        }
    }, [])

    useEffect(() => {
        setIsCollapseOpened(false);
        setIsModificationOpened(false);
        dispatch(setState("clearReviewTable", false));
    }, [clearReviewTable])

    const handleCountryChange = (e) => {
        const name = e.target.value;
        let countryID = 0;
        if (name !== "All") {
            countryID = countries.find(
                (country) => country.countryName === name
            ).countryID;
        }

        dispatch(setState("selectedCountry", name));
        dispatch(setState("selectedCountryID", countryID));
    }

    const handleOrderStatusChange = (e) => {
        const order = e.target.value;
        dispatch(setState("selectedOrderStatus", order));
    }

    const handlePeriodChange = (e) => {
        const period = e.target.value;
        dispatch(setState("selectedPeriod", period));
    }

    const handleSearchText = (e) => {
        setSearchText(e.target.value);
        dispatch(setState("searchTxt", e.target.value));
    }
    const showMessage = (message, severity) => {
        dispatch(setState("message", message));
        dispatch(setState("severity", severity));
        dispatch(setState("messageOpen", true));
    };
    const handleRetrive = () => {
        dispatch(reset("clear"));
        setIsCollapseOpened(false);
        setIsModificationOpened(false);
        if (selectedCountryID === null || selectedCountryID === "") {
            showMessage("Please select country", "info");
            return;
        }
        else if (selectedOrderStatus === null || selectedOrderStatus === "") {
            showMessage("Please select Order status", "info");
            return;
        }
        else if (selectedPeriod === null || selectedPeriod === "") {
            showMessage("Please select period", "info");
            return;
        }
        const obj = {
            countryID: selectedCountryID,
            orderStatus: selectedOrderStatus,
            searchText: searchText,
            period: selectedPeriod
        }

        const newObj = {
            scenarioId: null,
            quotaId: null
        }
        dispatch(GetScenarios(obj));
        dispatch(setState("clearQCTable", true));
        dispatch(setState("clearMTable", true));
    }

    const handleRowClick = (rowData) => {
        dispatch(setState("displayModification"), false);
        dispatch(setState("clearMTable", true));
        dispatch(reset("clear"));
        dispatch(setState("isModifyClicked", false));
        const date = new Date();

        var startdate = new Date(
            date.getFullYear(),
            date.getMonth(),
            1,
            6,
            30,
            0,
            0
        );
        startdate = startdate.toJSON();
        var lastdate = new Date(
            date.getFullYear(),
            date.getMonth() + 1,
            0,
            6,
            30,
            0,
            0
        );
        lastdate = lastdate.toJSON();
        if (selectedPeriod === "0") {
            startdate = new Date(
                date.getFullYear(),
                date.getMonth() - 1,
                1,
                6,
                30,
                0,
                0
            );
            startdate = startdate.toJSON();
            lastdate = new Date(
                date.getFullYear(),
                date.getMonth(),
                0,
                6,
                30,
                0,
                0
            );
            lastdate = lastdate.toJSON();
        }
        const dateObj = {
            quotaStartDate: startdate,
            quotaEndDate: lastdate
        }

        dispatch(GetWeekStatus(dateObj));
        console.log(rowData.row)
        const obj = {
            scenarioId: rowData.id,
            quotaId: rowData.row.quotaID
        }
        dispatch(setState("selectedScenario", rowData.row.scenarioName));
        dispatch(setState("selectedScenarioID", rowData.row.scenarioID));
        dispatch(setState("selectedQuotaID", rowData.row.quotaID));
        dispatch(GetQuotaDetailsForScenario(obj));
        setIsCollapseOpened(true);
    }

    //const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const getRowClassName = (params) => {
        return params.row.isModified ? 'modified-row' : '';
    };

    return (
        <div>
            <CollapseSection title="Review Order & Quota: List of scenarios for running period">
                <Box m={2}>
                    <Box>
                        <Backdrop
                            sx={{
                                color: "#fff",
                                zIndex: (theme) => theme.zIndex.drawer + 999,
                            }}
                            open={isLoading}
                        >
                            <CircularProgress />
                        </Backdrop>
                    </Box>
                    <Box>
                        <MessageForReview />
                    </Box>
                    <div style={{display : 'flex'}}>
                    <Typography variant="subtitle1" my={2} style = {{width : '50%'}}>
                        Search for Scenario
                    </Typography>
                    <div style = {{width : '50%'}}>
                    {getScenarios.length > 0 && <ExportIcons isQuotaConsumption={false}/>}
                    </div>
                    </div>
                    {/* <form onSubmit={handleSubmit(onSubmit)}> */}
                    {/* <Box className="scenario-search"> */}
                    <Grid container columns={12} justifyContent="space-between" alignItems="center" spacing={2} pb={1}>
                        <Grid item xs={6} sm={2} md={2} lg={2}>
                            <TextField
                                variant="outlined"
                                label="Country"
                                select={countries.length > 0 ? true : false}
                                //select={true}
                                value={countries.length > 0 ? selectedCountry : ""}
                                //value={""}
                                onChange={handleCountryChange}
                                fullWidth
                                size="small"
                            //disabled={countries.length > 0 ? false : true}
                            // {...register("country", {
                            //     required: "Please select a country",
                            // })}
                            // error={Boolean(errors.country)}
                            // helperText={errors ?.country ?.message}
                            >
                                {/* <MenuItem key={0} value={0}>
                     {"All"}
                     </MenuItem> */}
                                <MenuItem value={"All"}>{"All"}</MenuItem>
                                {countries.length > 0 ? (
                                    countries.map((country, index) => {
                                        return (
                                            <MenuItem key={country.countryID} value={country.countryName}>
                                                {country.countryName}
                                            </MenuItem>
                                        )
                                    })) : null
                                }

                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={2} md={2} lg={3}>
                            <TextField
                                variant="outlined"
                                label="Order Status"
                                select={orderStatus.length > 0 ? true : false}
                                value={orderStatus.length > 0 ? selectedOrderStatus : ""}
                                //select={true}
                                //value={""}
                                onChange={handleOrderStatusChange}
                                size="small"
                                fullWidth
                            //disabled={scenarioList.length > 0 ? false : true}
                            // required
                            // {...register("scenario", {
                            //     required: "Please select a scenario",
                            // })}
                            // error={Boolean(errors.scenario)}
                            // helperText={errors ?.scenario ?.message}
                            >
                                {orderStatus.length > 0 ? (
                                    orderStatus.map((order, index) => {
                                        return (
                                            <MenuItem key={order.key} value={order.value}>
                                                {order.value}
                                            </MenuItem>
                                        )
                                    })) : null
                                }
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={2} md={2} lg={3}>
                            <TextField
                                variant="outlined"
                                label="Period"
                                //select={quotaPeriods.length > 0 ? true : false}
                                //value={quotaPeriods.length > 0 ? selectedPeriod.displayDate : ""}
                                select={true}
                                value={selectedPeriod ? selectedPeriod : ""}
                                onChange={handlePeriodChange}
                                size="small"
                                fullWidth
                            //disabled={quotaPeriods.length > 0 ? false : true}
                            // {...register("currentPeriod", {
                            //     required: "Please select validity period.",
                            // })}
                            // error={Boolean(errors.currentPeriod)}
                            // helperText={errors ?.currentPeriod ?.message}
                            >
                                <MenuItem value="1">Current</MenuItem>
                                <MenuItem value="0">Previous</MenuItem>
                                {/* {quotaPeriods.length > 0 ? (
                            quotaPeriods.map((quota, index) => {
                                return (
                                    <MenuItem key={quota.displayDate} value={quota.displayDate}>
                                        {quota.displayDate}
                                    </MenuItem>
                                )
                            })) : null
                        } */}
                            </TextField>
                        </Grid>
                        <Grid item xs={6} sm={3} md={2.8} lg={2.8}>
                            <TextField
                                variant="outlined"
                                label="Search"
                                //select={countries.length > 0 ? true : false}
                                //value={countries.length > 0 ? selectedCountry.countryID : " "}
                                value={searchText}
                                onChange={handleSearchText}
                                fullWidth
                                size="small"
                            >
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={2} md={2} lg={1.2}>
                            <Box justifyContent="center" display="flex">
                                <Button
                                    startIcon={<SearchIcon />}
                                    variant="contained"
                                    onClick={handleRetrive}
                                    size="large"
                                // className="mui_Button"
                                //disabled={Object.keys(selectedPeriod).length === 0 || loadQuotaDetails ? true : false}
                                >
                                    Search
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                {getScenarios.length > 0 &&
                    <Box sx={{ mt: 3 }}>
                        <DataGrid style={{ maxHeight: 'calc(100vh - 130px)' }}
                            rows={getScenarios}
                            columns={columns}
                            getRowId={(row) => row?.scenarioID}
                            sx={{
                                "& .MuiDataGrid-columnHeaderTitleContainer": {
                                    fontWeight: "bold !important",
                                    fontSize: "14px",
                                    fontFamily: "Montserrat, Sans-serif"
                                },
                                "& .MuiDataGrid-columnHeaderTitle": {
                                    whiteSpace: "normal",
                                    lineHeight: "normal",
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                    fontFamily: "Montserrat, Sans-serif"
                                },
                                "& .MuiDataGrid-columnHeader": {
                                    // Forced to use !important since overriding inline styles
                                    height: "unset !important",
                                    backgroundColor: "rgba(235, 246, 250)"
                                },
                                "& .MuiDataGrid-columnHeaders": {
                                    // Forced to use !important since overriding inline styles
                                    maxHeight: "250px !important",
                                },
                                '& .MuiDataGrid-cell': {
                                    whiteSpace: 'normal !important',
                                    wordWrap: 'break-word !important',
                                }
                            }}
                            onRowClick={handleRowClick}
                            getRowClassName={getRowClassName}
                            disableColumnMenu
                            headerHeight={40}
                        />
                    </Box>
                }
            </CollapseSection>

            <CollapseSection title="Quota and Consumption" opened={isCollapseOpened} setIsCollapseOpened={setIsCollapseOpened}>
                {getQuotaDetails?.quotaCusumptionCustomers?.length > 0 &&
                    <Box sx={{ mt: 3 }}>
                        <QuotaandConsumption handleRowClick={handleRowClick} setIsModificationOpened={setIsModificationOpened} />
                    </Box>
                }
            </CollapseSection>

            <CollapseSection title="Modification" opened={isModificationOpened} setIsCollapseOpened={setIsModificationOpened}>
                {getQuotaDetails?.quotaCusumptionCustomers?.length > 0 &&
                    <Box sx={{ mt: 3 }}>
                        <Modification />
                    </Box>
                }
            </CollapseSection>

        </div>
    )
}

export default ReviewOrdersandQuota